import Api from "../Api";
import { Image } from "./types";

export async function getGalleryImages(filter)
{
    return await Api().get("/gallery/get-uploaded-images-for-gallery?filter="+filter);
}

export async function uploadGalleryImage(formData, config)
{
    return await Api().post("/gallery/upload-image", formData, config);
}

export async function deleteGalleryImages(formData) {
    return await Api().post("/gallery/delete-selected-images", formData);
}
export async function updateImageInfo(imageId: any, formData: Image) {
    return await Api().put(`/gallery/update-image-info/${imageId}`, formData);
}
